import { Component, OnInit } from "@angular/core";
import { ApiServicesService } from "../../Services/api-services.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  years: string[] = ["2022", "2023", "2024", "2025"];
  selectedYear: string = "2025";

  totalAttendees = 0;
  communities = 0;
  speakers = 0;
  sponsors = 0;
  faqs = 0;
  volunteers = 0;

  constructor(private apiCall: ApiServicesService) {}

  ngOnInit() {
    this.getEventData(this.selectedYear);
  }

  getEventData(year: string) {
    this.apiCall.getEventData(year).subscribe((resdata) => {
      console.log("Event Data for year " + year, resdata);

      if (resdata?.id) {
        localStorage.setItem("eventId", resdata.id.toString());
      }

      this.totalAttendees = resdata?.totalAttendees ?? 0;
      this.communities = resdata?.communities ?? 0;
      this.speakers = resdata?.speakers ?? 0;
      this.sponsors = resdata?.sponsors ?? 0;
      this.faqs = resdata?.faqs ?? 0;
      this.volunteers = resdata?.volunteers ?? 0;
    });
  }
}
